<template>
  <!-- Files and links of one part of a task: saved ones that can be removed, and new ones added before saving (US 9398) -->
  <div class="td-files">
    <span v-for="file in savedFiles" :key="'m' + file.id" class="td-file">
      <font-awesome-icon icon="paperclip"/>{{ file.file_name }}
      <button type="button" :aria-label="$t('task_dialog.attachments.remove')" qid="task-file-remove" @click="state.removedMedia.push(file.id)"><font-awesome-icon icon="times"/></button>
    </span>
    <span v-for="(file, index) in state.files[collection]" :key="'f' + index" class="td-file td-file--new">
      <font-awesome-icon icon="paperclip"/>{{ file.name }}
      <button type="button" :aria-label="$t('task_dialog.attachments.remove')" qid="task-new-file-remove" @click="state.files[collection].splice(index, 1)"><font-awesome-icon icon="times"/></button>
    </span>
    <span v-for="link in savedLinks" :key="'l' + link.id" class="td-file">
      <font-awesome-icon icon="link"/><a :href="link.url" target="_blank" rel="noopener">{{ link.name || link.url }}</a>
      <button type="button" :aria-label="$t('task_dialog.attachments.remove')" qid="task-link-remove" @click="state.removedLinks.push(link.id)"><font-awesome-icon icon="times"/></button>
    </span>
    <span v-for="(link, index) in state.links[collection]" :key="'n' + index" class="td-file td-file--new">
      <font-awesome-icon icon="link"/>{{ link.name || link.url }}
      <button type="button" :aria-label="$t('task_dialog.attachments.remove')" qid="task-new-link-remove" @click="state.links[collection].splice(index, 1)"><font-awesome-icon icon="times"/></button>
    </span>

    <label class="td-add" qid="task-file-add">
      <input type="file" multiple class="sr-only" @change="addFiles">
      <font-awesome-icon icon="plus"/>{{ $t('task_dialog.attachments.file') }}
    </label>
    <button v-if="!linkOpen" type="button" class="td-add" qid="task-link-add" @click="linkOpen = true">
      <font-awesome-icon icon="plus"/>{{ $t('task_dialog.attachments.link') }}
    </button>

    <div v-if="linkOpen" class="td-linkform">
      <input v-model="linkUrl" :placeholder="$t('task_dialog.attachments.url')" :aria-label="$t('task_dialog.attachments.url')" qid="task-link-url" @keydown.enter.prevent="addLink">
      <input v-model="linkName" :placeholder="$t('task_dialog.attachments.name')" :aria-label="$t('task_dialog.attachments.name')" qid="task-link-name" @keydown.enter.prevent="addLink">
      <b-button size="sm" variant="success" :disabled="!linkUrl.trim()" qid="task-link-save" @click="addLink">{{ $t('task_dialog.attachments.add') }}</b-button>
      <b-button size="sm" variant="secondary" @click="linkOpen = false">{{ $t('task_dialog.cancel') }}</b-button>
    </div>
    <div v-if="tooLarge" class="td-error">{{ $t('system.file_size_30') }}</div>
  </div>
</template>

<script>
  const MAX_SIZE = 31457280;

  export default {
    name: 'TaskAttachments',
    props: {
      // Shared with the dialog: { media, links, files, links, removedMedia, removedLinks }
      state: {
        type: Object,
        required: true
      },
      collection: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        linkOpen: false,
        linkUrl: '',
        linkName: '',
        tooLarge: false
      }
    },
    computed: {
      savedFiles() {
        return this.state.media.filter(file => file.collection_name === this.collection && this.state.removedMedia.indexOf(file.id) === -1);
      },
      // Links saved before collections existed belong to the task description
      savedLinks() {
        return this.state.savedLinks.filter(link => (link.collection || 'question') === this.collection && this.state.removedLinks.indexOf(link.id) === -1);
      }
    },
    methods: {
      addFiles(event) {
        let files = Array.from(event.target.files || []);
        this.tooLarge = files.some(file => file.size > MAX_SIZE);
        files.filter(file => file.size <= MAX_SIZE).forEach(file => this.state.files[this.collection].push(file));
        event.target.value = '';
      },
      addLink() {
        let url = this.linkUrl.trim();
        if (!url) {
          return;
        }
        if (!/^https?:\/\//i.test(url)) {
          url = 'https://' + url;
        }
        this.state.links[this.collection].push({ url: url, name: this.linkName.trim() });
        this.linkUrl = '';
        this.linkName = '';
        this.linkOpen = false;
      }
    }
  }
</script>
